export default function getLocale() {
  return navigator.languages?.length ? navigator.languages[0] : navigator.language
}
